module.exports = __webpack_public_path__ + "static/Hero-video--export-62fe1b0cf16f191aea27d20df93a53fc.mp4";